<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="competitorId">Competitor</label>
                    <wj-combo-box
                        id="competitorId"
                        [(ngModel)]="target.competitorId"
                        name="competitorId"
                        [itemsSource]="competitorsList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <hr />
        <div class="row">
            <div class="col-4">
                <div class="form-group">
                    <label for="designFee">Design Fee</label>
                    <wj-input-number
                        id="designFee"
                        [(ngModel)]="target.designFee"
                        name="designFee"
                        [isRequired]="false"
                        [format]="'n2'"
                    ></wj-input-number>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group">
                    <label for="cmFee">CM Fee</label>
                    <wj-input-number
                        id="cmFee"
                        [(ngModel)]="target.cmFee"
                        name="cmFee"
                        [isRequired]="false"
                        [format]="'n2'"
                    ></wj-input-number>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group">
                    <label for="cmMonthlyFee">CM Monthly Fee</label>
                    <wj-input-number
                        id="cmMonthlyFee"
                        [(ngModel)]="target.cmMonthlyFee"
                        name="cmMonthlyFee"
                        [isRequired]="false"
                        [format]="'n2'"
                    ></wj-input-number>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <div class="form-group">
                    <label for="contractorOhpFee">Contractor OHP Fee</label>
                    <wj-input-number
                        id="contractorOhpFee"
                        [(ngModel)]="target.contractorOhpFee"
                        name="contractorOhpFee"
                        [isRequired]="false"
                        [format]="'n2'"
                    ></wj-input-number>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group">
                    <label for="contractorBondsIns">Contractor Bonds/Ins</label>
                    <wj-input-number
                        id="contractorBondsIns"
                        [(ngModel)]="target.contractorBondsIns"
                        name="contractorBondsIns"
                        [isRequired]="false"
                        [format]="'n2'"
                    ></wj-input-number>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group">
                    <label for="contractorCoMarkup">Contractor CO Markup</label>
                    <wj-input-number
                        id="contractorCoMarkup"
                        [(ngModel)]="target.contractorCoMarkup"
                        name="contractorCoMarkup"
                        [isRequired]="false"
                        [format]="'n2'"
                    ></wj-input-number>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <div class="form-group">
                    <label for="cityBudget">City Budget</label>
                    <wj-input-number
                        id="cityBudget"
                        [(ngModel)]="target.cityBudget"
                        name="cityBudget"
                        [isRequired]="false"
                        [format]="'n2'"
                    ></wj-input-number>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group">
                    <label for="contractorStartDate">Contractor Start Date</label>
                    <wj-input-date
                        id="contractorStartDate"
                        [(ngModel)]="target.contractorStartDate"
                        name="contractorStartDate"
                        [isRequired]="false"
                    ></wj-input-date>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group">
                    <label for="contractorNumDays">Contractor Days</label>
                    <wj-input-number
                        id="contractorNumDays"
                        [(ngModel)]="target.contractorNumDays"
                        name="contractorNumDays"
                        [isRequired]="false"
                        [format]="'n0'"
                        [step]="1"
                    ></wj-input-number>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <div class="form-group">
                    <label for="contractorNumProjects">Contractor Projects</label>
                    <wj-input-number
                        id="contractorNumProjects"
                        [(ngModel)]="target.contractorNumProjects"
                        name="contractorNumProjects"
                        [isRequired]="false"
                        [format]="'n0'"
                        [step]="1"
                    ></wj-input-number>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group">
                    <label for="pmNumProjects">PM Projects</label>
                    <wj-input-number
                        id="pmNumProjects"
                        [(ngModel)]="target.pmNumProjects"
                        name="pmNumProjects"
                        [isRequired]="false"
                        [format]="'n0'"
                        [step]="1"
                    ></wj-input-number>
                </div>
            </div>
        </div>
        <hr />
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="contractorPm">Contractor PM</label>
                    <input
                        id="contractorPm"
                        type="text"
                        class="form-control"
                        [(ngModel)]="target.contractorPm"
                        name="contractorPm"
                        maxlength="500"
                    />
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="contractorSuper">Contractor Superintendent</label>
                    <input
                        id="contractorSuper"
                        type="text"
                        class="form-control"
                        [(ngModel)]="target.contractorSuper"
                        name="contractorSuper"
                        maxlength="500"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="contractorRef1">Reference 1</label>
                    <input
                        id="contractorRef1"
                        type="text"
                        class="form-control"
                        [(ngModel)]="target.contractorRef1"
                        name="contractorRef1"
                        maxlength="500"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="contractorRef2">Reference 2</label>
                    <input
                        id="contractorRef2"
                        type="text"
                        class="form-control"
                        [(ngModel)]="target.contractorRef2"
                        name="contractorRef2"
                        maxlength="500"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="contractorRef3">Reference 3</label>
                    <input
                        id="contractorRef3"
                        type="text"
                        class="form-control"
                        [(ngModel)]="target.contractorRef3"
                        name="contractorRef3"
                        maxlength="500"
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
